/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Exterior(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99984 2.9375C10.1798 2.9375 10.3576 2.96495 10.5321 3.02051C10.7062 3.07601 10.8689 3.15963 11.0203 3.27051L18.5203 9C18.7009 9.13889 18.8051 9.31977 18.8328 9.54199C18.8605 9.76412 18.8057 9.97262 18.6668 10.167C18.528 10.3475 18.347 10.4517 18.1248 10.4795C17.9027 10.5072 17.7009 10.4514 17.5203 10.3125L16.6668 9.6875V15.833C16.6668 16.2913 16.5036 16.6841 16.1776 17.0107C15.8515 17.3374 15.4587 17.5006 14.9998 17.5H4.99984C4.54157 17.5 4.14916 17.3368 3.82308 17.0107C3.49708 16.6847 3.3334 16.2918 3.33285 15.833V9.6875L2.49984 10.333C2.3054 10.4719 2.09706 10.5278 1.87484 10.5C1.65269 10.4722 1.47171 10.3614 1.33285 10.167C1.19403 9.97264 1.14267 9.7641 1.17757 9.54199C1.21257 9.31981 1.3199 9.13888 1.49984 9L8.97933 3.27051C9.13203 3.1595 9.29578 3.07603 9.46957 3.02051C9.64326 2.96507 9.82005 2.93752 9.99984 2.9375ZM4.99984 8.41699V15.833H14.9998V8.41699L9.99984 4.60449L4.99984 8.41699Z"
        fill="#35424F"
      />
    </svg>
  )
}

Exterior.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Exterior
